import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { LanguageConfigEffects } from './lib/store/language-config/language-config.effects';
import {
  LanguageConfigNamespace,
  LanguageConfigReducer,
} from './lib/store/language-config/language-config.store';

export { LanguagesDataModule } from './lib/languages-data.module';
export {
  LanguageConfigActions,
  LanguageConfigSelectors,
} from './lib/store/language-config/language-config.store';

export {
  LanguageTranslationsActions,
  LanguageTranslationsSelectors,
} from './lib/store/language-translations/language-translations.store';

export {
  PossibleLanguagesActions,
  PossibleLanguagesSelectors,
} from './lib/store/possible-languages/possible-languages.store';

export {
  LanguageListActions,
  LanguageListSelectors,
} from './lib/store/language-list/language-list.store';

export { ViewboxLanguagesActions } from './lib/viewbox-languages/viewbox-languages.store';

export { ViewboxLanguagesDataModule } from './lib/viewbox-languages/viewbox-languages-data.module';

export * from './lib/viewbox-languages/types';

export const languageConfigEffectsProvider = provideEffects([LanguageConfigEffects]);

export const languageConfigStateProvider = provideState(
  LanguageConfigNamespace,
  LanguageConfigReducer,
);

export const languageConfigData = [languageConfigEffectsProvider, languageConfigStateProvider];
